export const translations = {
  en: {
    // Language selector
    languageToggle: {
      en: 'English',
      es: 'Español',
    },
    
    // Estimator header
    estimator: {
      title: 'Accident Settlement Estimator',
      subtitle: 'Get your free estimate in 2 minutes',
      step: 'Step',
      of: 'of',
      back: 'Back',
      next: 'Next',
      getResults: 'Get My Estimate',
      selectToContinue: 'Select an option to continue',
    },
    
    // Question 1: Accident Type
    accidentType: {
      question: 'What type of accident were you in?',
      options: {
        rearEnd: 'Rear-end collision',
        tBone: 'T-bone (side impact)',
        headOn: 'Head-on collision',
        motorcycle: 'Motorcycle accident',
        truck: 'Truck / Commercial vehicle',
        pedestrian: 'Pedestrian / Bicycle',
      },
    },
    
    // Question 2: ER Visit
    erVisit: {
      question: 'Did you go to the ER or hospital?',
      options: {
        yes: 'Yes',
        no: 'No',
      },
    },
    
    // Question 3: Injury Severity
    injurySeverity: {
      question: 'What injuries best describe your situation?',
      options: {
        none: 'No injury / soreness only',
        softTissue: 'Soft tissue (whiplash, strains)',
        fracture: 'Fracture',
        surgery: 'Surgery required',
        permanent: 'Permanent injury / disability',
      },
    },
    
    // Question 4: Missed Work
    missedWork: {
      question: 'Did you miss work due to the accident?',
      options: {
        no: 'No',
        days: '1–7 days',
        weeks: '1–4 weeks',
        months: '1+ months',
      },
    },
    
    // Question 5: Fault
    fault: {
      question: 'Was the other driver at fault?',
      options: {
        yes: 'Yes',
        unsure: 'Unsure',
        no: 'No',
      },
    },
    
    // Question 6: Police Report
    policeReport: {
      question: 'Did police respond and create a report?',
      options: {
        yes: 'Yes',
        no: 'No',
      },
    },
    
    // Question 7: City & State
    city: {
      question: 'Where did the accident occur?',
      cityLabel: 'City',
      cityPlaceholder: 'Enter city name',
      stateLabel: 'State',
      statePlaceholder: 'Select state',
      detectingLocation: 'Detecting your location...',
      locationDetected: 'Location detected',
      locationFailed: 'Could not detect location',
    },
    
    // Results Screen
    results: {
      title: 'Your Estimated Claim Range',
      description: 'Based on similar injury cases involving the details you provided, settlements often fall between:',
      disclaimer: 'This estimate is based on publicly reported settlements with similar injuries, medical treatment, and liability factors. Every case is different, and only a licensed attorney can provide a formal evaluation.',
      nextStepTitle: 'Next Step',
      nextStepText: 'To find out where your case truly falls inside this range, an injury attorney must review your police report and medical records.',
      ctaText: 'If you\'d like a free attorney review, enter your contact details below and we\'ll connect you at no cost.',
    },
    
    // Lead Form
    leadForm: {
      nameLabel: 'Full Name',
      namePlaceholder: 'Enter your full name',
      phoneLabel: 'Phone Number',
      phonePlaceholder: '(555) 555-5555',
      emailLabel: 'Email Address',
      emailPlaceholder: 'your@email.com',
      submitButton: 'Get My Free Attorney Review',
      submitting: 'Submitting...',
      consentText: 'I agree to be contacted by phone or text regarding my accident at the number I provided. I understand consent is not required to receive services.',
      legalDisclaimer: 'This is not legal advice. Submitting this form does not create an attorney-client relationship. Settlement estimates are based on historical cases and do not guarantee results.',
    },
    
    // Success Screen
    success: {
      title: 'Thank You!',
      message: 'Your information has been submitted successfully. An injury attorney will review your case and contact you shortly.',
      note: 'Please keep your phone nearby — you should receive a call or text within the next 24 hours.',
    },
    
    // Landing Page
    landing: {
      heroTitle: 'What\'s Your Accident Claim Worth?',
      heroSubtitle: 'Free 2-minute estimator shows what similar cases have settled for — no obligation, completely confidential.',
      ctaButton: 'Get Your Free Estimate',
      noObligation: 'No obligation • 100% free • Takes 2 minutes',
      feature1Title: 'Real Settlement Data',
      feature1Text: 'Our estimates are based on actual settlement data from cases with similar injuries and circumstances.',
      feature2Title: 'Quick & Confidential',
      feature2Text: '7 simple questions. No personal information required upfront. Your privacy is protected.',
      feature3Title: 'Free Attorney Review',
      feature3Text: 'Get connected with a licensed injury attorney who can evaluate your specific case at no cost.',
    },
    
    // Admin/Leads Pages
    admin: {
      // Header
      adminButton: 'Admin',
      logout: 'Logout',
      backToLeads: 'Back to Leads',
      adminSettings: 'Admin Settings',
      
      // Leads Page
      yourReferralLink: 'Your Referral Link',
      referralLinkDescription: 'Share this link with your contacts. All leads submitted through this link will appear below.',
      copyLink: 'Copy Link',
      yourLeads: 'Your Leads',
      allLeads: 'All Leads',
      noLeadsYet: 'No leads yet',
      shareToCollect: 'Share your referral link to start collecting leads!',
      
      // Table Headers
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      settlementRange: 'Settlement Range',
      city: 'City',
      date: 'Date',
      refCode: 'Ref Code',
      status: 'Status',
      
      // Lead Status
      statusNew: 'New',
      statusRead: 'Read',
      statusReferral: 'Referral',
      markAsReferral: 'Mark as Referral',
      markedAsReferral: 'Marked as Referral',
      
      // Search & Pagination
      searchPlaceholder: 'Search by name, email, or phone...',
      showing: 'Showing',
      of: 'of',
      leadsPerPage: 'per page',
      previous: 'Previous',
      next: 'Next',
      noResults: 'No leads match your search',
      
      // Password Change
      passwordChangeRequired: 'Password Change Required',
      passwordChangeMessage: 'For security, please set a new password for your account.',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      changePassword: 'Change Password',
      passwordChanged: 'Password changed successfully!',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      
      // Notes
      notes: 'Notes',
      notesPlaceholder: 'Add notes about this lead...',
      saveNotes: 'Save Notes',
      notesSaved: 'Notes saved',
      
      // Reassign
      reassignLead: 'Reassign',
      reassignTo: 'Reassign to',
      selectUser: 'Select user',
      reassignConfirm: 'Reassign Lead',
      leadsReassigned: 'Lead(s) reassigned successfully',
      
      // Delete & Bulk Actions
      deleteLead: 'Delete Lead',
      deleteConfirmTitle: 'Delete Lead?',
      deleteConfirmMessage: 'Are you sure you want to delete this lead? This action cannot be undone.',
      deleteConfirmButton: 'Yes, Delete',
      bulkDeleteConfirmTitle: 'Delete Selected Leads?',
      bulkDeleteConfirmMessage: 'Are you sure you want to delete {count} lead(s)? This action cannot be undone.',
      selectedCount: '{count} selected',
      bulkMarkReferral: 'Mark as Referral',
      bulkDelete: 'Delete',
      selectAll: 'Select All',
      
      // Lead Detail Dialog
      leadDetails: 'Lead Details',
      contactInformation: 'Contact Information',
      estimatedSettlementRange: 'Estimated Settlement Range',
      formResponses: 'Form Responses',
      submissionDetails: 'Submission Details',
      submitted: 'Submitted',
      language: 'Language',
      referralCode: 'Referral Code',
      directNoReferral: 'Direct (no referral)',
      homepage: 'Homepage',
      consentGiven: 'Consent Given',
      yes: 'Yes',
      no: 'No',
      close: 'Close',
      
      // Admin Dashboard
      platformSettings: 'Platform Settings',
      userManagement: 'User Management',
      platformName: 'Platform Name',
      platformNameHelper: 'Displayed in header and footer',
      platformTagline: 'Platform Tagline',
      platformTaglineHelper: 'Displayed on landing page',
      companyName: 'Company Name',
      companyNameHelper: 'Used in copyright notice',
      saveSettings: 'Save Settings',
      settingsSaved: 'Settings saved successfully!',
      users: 'Users',
      addUser: 'Add User',
      role: 'Role',
      referralLink: 'Referral Link',
      created: 'Created',
      noUsersYet: 'No users yet',
      
      // Create User Dialog
      addNewUser: 'Add New User',
      password: 'Password',
      passwordHelper: 'Set a password for the new user (min 6 characters)',
      userName: 'Full Name',
      userPhone: 'Phone Number (SMS)',
      userPhoneHelper: 'For receiving new lead notifications via text',
      userLeadGen: 'User (Lead Gen)',
      createUserNote: 'A referral code will be auto-generated. User will be required to change password on first login.',
      cancel: 'Cancel',
      createUser: 'Create User',
      
      // Edit User
      editUser: 'Edit User',
      saveChanges: 'Save Changes',
      userUpdated: 'User updated successfully',
      
      // Delete User
      deleteUser: 'Delete User',
      deleteUserConfirm: 'Are you sure you want to delete this user? This action cannot be undone.',
      userDeleted: 'User deleted successfully',
      
      // Disable User
      disableUser: 'Disable User',
      enableUser: 'Enable User',
      userDisabled: 'Disabled',
      userEnabled: 'Active',
      
      // User Search
      searchUsers: 'Search by name, email, or phone...',
      actions: 'Actions',
      
      // Form Answer Labels
      accidentTypeLabel: 'Accident Type',
      erVisitLabel: 'ER/Hospital Visit',
      injurySeverityLabel: 'Injury Severity',
      missedWorkLabel: 'Missed Work',
      faultLabel: 'Other Driver at Fault',
      policeReportLabel: 'Police Report',
      cityLabel: 'City',
      stateLabel: 'State',
    },
  },
  
  es: {
    // Language selector
    languageToggle: {
      en: 'English',
      es: 'Español',
    },
    
    // Estimator header
    estimator: {
      title: 'Estimador de Acuerdos por Accidentes',
      subtitle: 'Obtenga su estimación gratuita en 2 minutos',
      step: 'Paso',
      of: 'de',
      back: 'Atrás',
      next: 'Siguiente',
      getResults: 'Obtener Mi Estimación',
      selectToContinue: 'Seleccione una opción para continuar',
    },
    
    // Question 1: Accident Type
    accidentType: {
      question: '¿En qué tipo de accidente estuvo?',
      options: {
        rearEnd: 'Colisión trasera',
        tBone: 'Colisión lateral (T-bone)',
        headOn: 'Colisión frontal',
        motorcycle: 'Accidente de motocicleta',
        truck: 'Camión / Vehículo comercial',
        pedestrian: 'Peatón / Bicicleta',
      },
    },
    
    // Question 2: ER Visit
    erVisit: {
      question: '¿Fue a la sala de emergencias o al hospital?',
      options: {
        yes: 'Sí',
        no: 'No',
      },
    },
    
    // Question 3: Injury Severity
    injurySeverity: {
      question: '¿Qué lesiones describen mejor su situación?',
      options: {
        none: 'Sin lesión / solo dolor',
        softTissue: 'Tejido blando (latigazo cervical, esguinces)',
        fracture: 'Fractura',
        surgery: 'Cirugía requerida',
        permanent: 'Lesión permanente / discapacidad',
      },
    },
    
    // Question 4: Missed Work
    missedWork: {
      question: '¿Faltó al trabajo debido al accidente?',
      options: {
        no: 'No',
        days: '1–7 días',
        weeks: '1–4 semanas',
        months: '1+ meses',
      },
    },
    
    // Question 5: Fault
    fault: {
      question: '¿Fue culpa del otro conductor?',
      options: {
        yes: 'Sí',
        unsure: 'No estoy seguro',
        no: 'No',
      },
    },
    
    // Question 6: Police Report
    policeReport: {
      question: '¿La policía respondió y creó un informe?',
      options: {
        yes: 'Sí',
        no: 'No',
      },
    },
    
    // Question 7: City & State
    city: {
      question: '¿Dónde ocurrió el accidente?',
      cityLabel: 'Ciudad',
      cityPlaceholder: 'Ingrese el nombre de la ciudad',
      stateLabel: 'Estado',
      statePlaceholder: 'Seleccione estado',
      detectingLocation: 'Detectando su ubicación...',
      locationDetected: 'Ubicación detectada',
      locationFailed: 'No se pudo detectar la ubicación',
    },
    
    // Results Screen
    results: {
      title: 'Su Rango Estimado de Reclamación',
      description: 'Basado en casos similares de lesiones con los detalles que proporcionó, los acuerdos generalmente están entre:',
      disclaimer: 'Esta estimación se basa en acuerdos reportados públicamente con lesiones, tratamiento médico y factores de responsabilidad similares. Cada caso es diferente, y solo un abogado licenciado puede proporcionar una evaluación formal.',
      nextStepTitle: 'Siguiente Paso',
      nextStepText: 'Para saber dónde cae realmente su caso dentro de este rango, un abogado de lesiones debe revisar su informe policial y registros médicos.',
      ctaText: 'Si desea una revisión gratuita de un abogado, ingrese sus datos de contacto a continuación y lo conectaremos sin costo.',
    },
    
    // Lead Form
    leadForm: {
      nameLabel: 'Nombre Completo',
      namePlaceholder: 'Ingrese su nombre completo',
      phoneLabel: 'Número de Teléfono',
      phonePlaceholder: '(555) 555-5555',
      emailLabel: 'Correo Electrónico',
      emailPlaceholder: 'su@correo.com',
      submitButton: 'Obtener Mi Revisión Gratuita',
      submitting: 'Enviando...',
      consentText: 'Acepto ser contactado por teléfono o mensaje de texto sobre mi accidente al número que proporcioné. Entiendo que el consentimiento no es necesario para recibir servicios.',
      legalDisclaimer: 'Esto no es asesoramiento legal. Enviar este formulario no crea una relación abogado-cliente. Las estimaciones de acuerdos se basan en casos históricos y no garantizan resultados.',
    },
    
    // Success Screen
    success: {
      title: '¡Gracias!',
      message: 'Su información ha sido enviada exitosamente. Un abogado de lesiones revisará su caso y se comunicará con usted pronto.',
      note: 'Por favor mantenga su teléfono cerca — debería recibir una llamada o mensaje de texto dentro de las próximas 24 horas.',
    },
    
    // Landing Page
    landing: {
      heroTitle: '¿Cuánto Vale Su Reclamación por Accidente?',
      heroSubtitle: 'Estimador gratuito de 2 minutos muestra lo que casos similares han resuelto — sin obligación, completamente confidencial.',
      ctaButton: 'Obtener Su Estimación Gratuita',
      noObligation: 'Sin obligación • 100% gratis • Toma 2 minutos',
      feature1Title: 'Datos Reales de Acuerdos',
      feature1Text: 'Nuestras estimaciones se basan en datos reales de acuerdos de casos con lesiones y circunstancias similares.',
      feature2Title: 'Rápido y Confidencial',
      feature2Text: '7 preguntas simples. No se requiere información personal por adelantado. Su privacidad está protegida.',
      feature3Title: 'Revisión Gratuita de Abogado',
      feature3Text: 'Conéctese con un abogado de lesiones licenciado que puede evaluar su caso específico sin costo.',
    },
    
    // Admin/Leads Pages
    admin: {
      // Header
      adminButton: 'Admin',
      logout: 'Cerrar Sesión',
      backToLeads: 'Volver a Leads',
      adminSettings: 'Configuración de Admin',
      
      // Leads Page
      yourReferralLink: 'Tu Enlace de Referido',
      referralLinkDescription: 'Comparte este enlace con tus contactos. Todos los leads enviados a través de este enlace aparecerán abajo.',
      copyLink: 'Copiar Enlace',
      yourLeads: 'Tus Leads',
      allLeads: 'Todos los Leads',
      noLeadsYet: 'Aún no hay leads',
      shareToCollect: '¡Comparte tu enlace de referido para comenzar a recolectar leads!',
      
      // Table Headers
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Correo',
      settlementRange: 'Rango de Acuerdo',
      city: 'Ciudad',
      date: 'Fecha',
      refCode: 'Código Ref',
      status: 'Estado',
      
      // Lead Status
      statusNew: 'Nuevo',
      statusRead: 'Leído',
      statusReferral: 'Referido',
      markAsReferral: 'Marcar como Referido',
      markedAsReferral: 'Marcado como Referido',
      
      // Search & Pagination
      searchPlaceholder: 'Buscar por nombre, correo o teléfono...',
      showing: 'Mostrando',
      of: 'de',
      leadsPerPage: 'por página',
      previous: 'Anterior',
      next: 'Siguiente',
      noResults: 'Ningún lead coincide con tu búsqueda',
      
      // Password Change
      passwordChangeRequired: 'Cambio de Contraseña Requerido',
      passwordChangeMessage: 'Por seguridad, establezca una nueva contraseña para su cuenta.',
      currentPassword: 'Contraseña Actual',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Nueva Contraseña',
      changePassword: 'Cambiar Contraseña',
      passwordChanged: '¡Contraseña cambiada exitosamente!',
      passwordMismatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
      
      // Notes
      notes: 'Notas',
      notesPlaceholder: 'Agregar notas sobre este lead...',
      saveNotes: 'Guardar Notas',
      notesSaved: 'Notas guardadas',
      
      // Reassign
      reassignLead: 'Reasignar',
      reassignTo: 'Reasignar a',
      selectUser: 'Seleccionar usuario',
      reassignConfirm: 'Reasignar Lead',
      leadsReassigned: 'Lead(s) reasignado(s) exitosamente',
      
      // Delete & Bulk Actions
      deleteLead: 'Eliminar Lead',
      deleteConfirmTitle: '¿Eliminar Lead?',
      deleteConfirmMessage: '¿Estás seguro de que quieres eliminar este lead? Esta acción no se puede deshacer.',
      deleteConfirmButton: 'Sí, Eliminar',
      bulkDeleteConfirmTitle: '¿Eliminar Leads Seleccionados?',
      bulkDeleteConfirmMessage: '¿Estás seguro de que quieres eliminar {count} lead(s)? Esta acción no se puede deshacer.',
      selectedCount: '{count} seleccionado(s)',
      bulkMarkReferral: 'Marcar como Referido',
      bulkDelete: 'Eliminar',
      selectAll: 'Seleccionar Todo',
      
      // Lead Detail Dialog
      leadDetails: 'Detalles del Lead',
      contactInformation: 'Información de Contacto',
      estimatedSettlementRange: 'Rango Estimado de Acuerdo',
      formResponses: 'Respuestas del Formulario',
      submissionDetails: 'Detalles de Envío',
      submitted: 'Enviado',
      language: 'Idioma',
      referralCode: 'Código de Referido',
      directNoReferral: 'Directo (sin referido)',
      homepage: 'Página Principal',
      consentGiven: 'Consentimiento Dado',
      yes: 'Sí',
      no: 'No',
      close: 'Cerrar',
      
      // Admin Dashboard
      platformSettings: 'Configuración de Plataforma',
      userManagement: 'Gestión de Usuarios',
      platformName: 'Nombre de Plataforma',
      platformNameHelper: 'Se muestra en el encabezado y pie de página',
      platformTagline: 'Eslogan de Plataforma',
      platformTaglineHelper: 'Se muestra en la página principal',
      companyName: 'Nombre de Empresa',
      companyNameHelper: 'Usado en el aviso de copyright',
      saveSettings: 'Guardar Configuración',
      settingsSaved: '¡Configuración guardada exitosamente!',
      users: 'Usuarios',
      addUser: 'Agregar Usuario',
      role: 'Rol',
      referralLink: 'Enlace de Referido',
      created: 'Creado',
      noUsersYet: 'Aún no hay usuarios',
      
      // Create User Dialog
      addNewUser: 'Agregar Nuevo Usuario',
      password: 'Contraseña',
      passwordHelper: 'Establece una contraseña para el nuevo usuario (mín 6 caracteres)',
      userName: 'Nombre Completo',
      userPhone: 'Número de Teléfono (SMS)',
      userPhoneHelper: 'Para recibir notificaciones de nuevos leads por mensaje de texto',
      userLeadGen: 'Usuario (Lead Gen)',
      createUserNote: 'Se generará un código de referido automáticamente. El usuario deberá cambiar la contraseña en su primer inicio de sesión.',
      cancel: 'Cancelar',
      createUser: 'Crear Usuario',
      
      // Edit User
      editUser: 'Editar Usuario',
      saveChanges: 'Guardar Cambios',
      userUpdated: 'Usuario actualizado exitosamente',
      
      // Delete User
      deleteUser: 'Eliminar Usuario',
      deleteUserConfirm: '¿Estás seguro de que quieres eliminar este usuario? Esta acción no se puede deshacer.',
      userDeleted: 'Usuario eliminado exitosamente',
      
      // Disable User
      disableUser: 'Deshabilitar Usuario',
      enableUser: 'Habilitar Usuario',
      userDisabled: 'Deshabilitado',
      userEnabled: 'Activo',
      
      // User Search
      searchUsers: 'Buscar por nombre, correo o teléfono...',
      actions: 'Acciones',
      
      // Form Answer Labels
      accidentTypeLabel: 'Tipo de Accidente',
      erVisitLabel: 'Visita a Emergencias/Hospital',
      injurySeverityLabel: 'Gravedad de Lesión',
      missedWorkLabel: 'Trabajo Perdido',
      faultLabel: 'Otro Conductor Culpable',
      policeReportLabel: 'Informe Policial',
      cityLabel: 'Ciudad',
      stateLabel: 'Estado',
    },
  },
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang];
  for (const key of keys) {
    if (result && result[key]) {
      result = result[key];
    } else {
      // Fallback to English
      result = translations.en;
      for (const fallbackKey of keys) {
        if (result && result[fallbackKey]) {
          result = result[fallbackKey];
        } else {
          return path; // Return path if translation not found
        }
      }
      break;
    }
  }
  return result;
};
